module.exports = __webpack_public_path__ + "static/img/middle-aikm.4cf2136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/middle-aikm.png
// module id = g0uR
// module chunks = 9